// import { gsap } from 'gsap';

export default class Header {
  constructor() {
    this.headerEl = document.querySelector('.main-header');
    this.svgWave = this.headerEl.querySelector('.svg-bg-wrapper');
    this.offcanvasMenu = this.headerEl.querySelector('.offcanvas-menu');
    this.starsCanvas = this.headerEl.querySelector('#starscanvas');
    this.ctx = this.starsCanvas.getContext('2d');
    this.isWorking = false;
    this.starSize = 2;
    this.numberOfStars = 100;

    this.body = document.body;
    this.isMenuWorking = false;
    this.debounce_timer = null;

    this.init();
    this.events();

  }

  init() {
    if (this.ctx) {
      this.ctx.canvas.width  = window.innerWidth;
      this.ctx.canvas.height = window.innerHeight;
    }
  }

  getRandomInt(max) {
    return Math.floor(Math.random() * max);
  }

  clearCanvas() {
    this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height)
  }

  onStickyHeaderShow() {
    this.isMenuWorking = true;
    // window.containerSticky.addClass('active');
    this.headerEl.classList.add('is-sticky');
    this.body.classList.add('has-sticky-header');
    gsap.to(this.svgWave, { duration: 0.4, y: 0, ease: 'power4.in', onComplete: () => {
      window.dispatchEvent(new CustomEvent('stickyHeader.show'));
      this.isMenuWorking = false;
    }});
    // gsap.to(window.containerSticky, {duration: 0.3, y: 0, delay: 0.3, onComplete: () => {
    // }});
  }

  onStickyHeaderHide() {
    this.isMenuWorking = true;
    gsap.to(this.svgWave, { duration: 0.4, y: '-100%', ease: 'power4.in', onComplete: () => {
			window.dispatchEvent(new CustomEvent('stickyHeader.hide'));
      this.isMenuWorking = false;
    } });
    // gsap.to(window.containerSticky, {duration: 0.3, y: '-103%'});
    // gsap.to(window.container, {duration: 0.3, y: 0, delay: 0.3, onComplete: () => {
    // }});
    this.headerEl.classList.remove('is-sticky');
    this.body.classList.remove('has-sticky-header');
    // window.containerSticky.removeClass('active');
  }

  onScroll() {
      if(this.debounce_timer) {
        window.clearTimeout(this.debounce_timer);
      }

      this.debounce_timer = window.setTimeout(() => {
        if (document.body.classList.contains('main-menu-open')) return;

        if ( this.isMenuWorking ) return;

        let pageYOffset = window.pageYOffset || document.body.scrollTop;

        // console.log(pageYOffset);

        if (100 < pageYOffset) {
          this.onStickyHeaderShow();
        } else {
          this.onStickyHeaderHide();
        }
      }, 50);
  }

  drawStar() {
    if (this.ctx) {
      const x = this.getRandomInt(this.ctx.canvas.width);
      const y = this.getRandomInt(this.ctx.canvas.height);
      const starOpacity = this.getRandomInt(100) / 200;

      this.ctx.fillStyle = `rgba(255, 255, 255, ${starOpacity})`;

      const star = new Path2D(`M${x} ${y} h ${this.starSize} v ${this.starSize} h ${this.starSize} v ${this.starSize} h -${this.starSize} v ${this.starSize} h -${this.starSize} v -${this.starSize} h -${this.starSize} v -${this.starSize} h ${this.starSize} Z`);
      this.ctx.fill(star);
    }
  }

  drawAllStars() {
    if (this.ctx && window.innerWidth >= 992) {
      for (let i = 0; i < this.numberOfStars; i++) {
        this.drawStar();
      }
    }
  }

  onMainMenuOpen(ev) {
    if (this.isWorking) return false;
    this.isWorking = true;

    this.ctx.canvas.width  = window.innerWidth;
    this.ctx.canvas.height = window.innerHeight;

    this.drawAllStars.bind(this)();

    this.onStickyHeaderHide();

    gsap.to(this.offcanvasMenu, {duration: .5, y: 0, ease: 'power4.easeOut', onComplete: () => {
      this.isWorking = false;
    }});
  }

  onMainMenuClose(ev) {
    if (this.isWorking) return false;
    this.isWorking = true;

    gsap.to(this.offcanvasMenu, {duration: .5, y: '-100%', ease: 'power4.easeIn', onComplete: () => {
      this.clearCanvas();
      window.dispatchEvent(new Event('scroll'));
      this.isWorking = false;
    }});
  }

  onWindowResize(ev) {

  }

  events() {
    window.addEventListener('scroll', this.onScroll.bind(this), false);
    window.addEventListener('resize', this.onWindowResize.bind(this), false);
    window.addEventListener('mainMenu.open', this.onMainMenuOpen.bind(this), false);
    window.addEventListener('mainMenu.close', this.onMainMenuClose.bind(this), false);
  }
}
